// extracted by mini-css-extract-plugin
export default {"mediaBody":"GMnTohDgg_0tyjGIgAuN"};